import { AI_DASHBOARDS_PATH } from "@/constants";
import { SimpleButton } from "./SimpleButton";

export function AIDashboardsButton({ isActive }: { isActive: boolean }) {
  return (
    <SimpleButton
      icon="SpotIQ"
      label="AI Dashboards"
      href={AI_DASHBOARDS_PATH}
      isActive={isActive}
    />
  );
}
